import { combineReducers } from "redux"
import { default as list } from "./list"
import { default as edit } from "./edit"

export default combineReducers({
  list,
  edit
})
